import { render } from "./Standard.vue?vue&type=template&id=3700ca78"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"

import "./Standard.vue?vue&type=style&index=0&id=3700ca78&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__